import { controls,grouped } from "../controls";
const append_calamity_fund_transactions = {
label: "Append Calamity Fund Transactions",
visitingBranches: 'readonly',
pageLabel: "Append Calamity Fund Transactions",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Account No",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "account_no",maxlength:20 ,isReadOnly:"edit" ,isRequired:true}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "IFSC",star:false}),
...controls.ifsc({ tab: "general",  placeHolder: "", name: "ifsc",maxlength:11}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Check at bank"}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Check at bank", name: "bank_account_code" ,isReadOnly:"edit" ,displayData:{account_display:"bank_account_display"},hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "bank_account_display"}),
...controls.displayText({ tab: "general", label: "Full Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "full_name",width:"col-sm-4",maxlength:500 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "Total Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "total_amount",maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Mobile",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "mobile",maxlength:10 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Append Calamity Fund Transactions",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Account No",accessor: "account_no",},
{Header: "IFSC",accessor: "ifsc",},
{Header: "Check at bank",accessor: "bank_account_code",},
{Header: "Full Name",accessor: "full_name",},
{Header: "Total Amount",accessor: "total_amount",},
{Header: "Mobile",accessor: "mobile",},
]}};
export default append_calamity_fund_transactions;